import { useQuery } from "@tanstack/react-query";
import { floorplansApi } from "@/lib/api/client";
import { directionsPlan, type DirectionsPlan, type PortalFloorplanDetail } from "./plan";

/** Plan `id` for the directions view, through the floor plan page's own query (the plan on screen is already
 *  loaded), worked out once per response (see plan.ts). */
export function useDirectionsPlan(id: number | null | undefined): DirectionsPlan | null {
  const { data } = useQuery({
    queryKey: ["floorplan", id],
    queryFn: () => floorplansApi.get(id!).then((r) => r.data as PortalFloorplanDetail),
    enabled: id != null,
    staleTime: 5 * 60_000,
  });
  return data?.svg_content ? directionsPlan(data) : null;
}
